import type { CSSProperties } from 'react';

import type { IconProps } from '../components/IconSvg';
import { IconSvg } from '../components/IconSvg';

interface ChevronIconProps extends IconProps {
  orientation?: 'up' | 'down' | 'left' | 'right';
}

const transforms = {
  up: 'rotate(-90deg)',
  down: 'rotate(90deg)',
  left: 'rotate(-180deg)',
  right: 'rotate(0deg)',
};

export function Chevron(props: ChevronIconProps) {
  const { orientation = 'right', ...svgProps } = props;
  const style: CSSProperties = {
    ...props.style,
    transform: transforms[orientation],
  };

  return (
    <IconSvg {...svgProps} style={style} height={props.height ?? 36}>
      <path d="M12.9697 27.5304C12.7034 27.2641 12.6792 26.8475 12.897 26.5538L12.9696 26.4697L21.437 18.002L12.9696 9.53316C12.7034 9.26687 12.6792 8.85021 12.8971 8.55661L12.9697 8.4725C13.236 8.20625 13.6527 8.18207 13.9462 8.39994L14.0304 8.47256L23.0278 17.4711C23.294 17.7374 23.3182 18.154 23.1004 18.4476L23.0278 18.5317L14.0304 27.5303C13.7375 27.8232 13.2626 27.8232 12.9697 27.5304Z" />
    </IconSvg>
  );
}
